import gql from 'graphql-tag';
export const CountryFragment = gql`
    fragment CountryFragment on Country {
  id
  name
  countryCode
}
    `;
export const CountryWithLanguagesFragment = gql`
    fragment CountryWithLanguagesFragment on Country {
  id
  name
  countryCode
  languages {
    id
    name
    languageCode
    shortNameEng
  }
}
    `;
export const PropertyItemFragment = gql`
    fragment PropertyItemFragment on PropertyItem {
  id
  type
  key
  data
  list
  contextId
  updatedAt
  createdAt
  updatedBy {
    user_id
    name
  }
  resolvedData {
    __typename
    ... on MediaItem {
      id
      name
      url
    }
  }
}
    `;
export const LanguageFragment = gql`
    fragment LanguageFragment on Language {
  id
  languageCode
  languageTag
  countryCode
  name
  shortName
  shortNameEng
}
    `;
export const ContentItemFragment = gql`
    fragment ContentItemFragment on ContentItemV2 {
  id
  key
  translationType
  variant
  contextId
  list
  language {
    ...LanguageFragment
  }
  data
  status
  createdAt
  updatedAt
  updatedBy {
    user_id
    name
  }
}
    ${LanguageFragment}`;
export const FilterTaxonomyRuleFragment = gql`
    fragment FilterTaxonomyRuleFragment on FilterTaxonomyRule {
  id
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  properties {
    ...PropertyItemFragment
  }
  content {
    ...ContentItemFragment
  }
  network {
    id
  }
  taxonomyBase {
    id
    content {
      ...ContentItemFragment
    }
  }
  taxonomyFilter {
    id
    content {
      ...ContentItemFragment
    }
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const LanguageWithCountriesFragment = gql`
    fragment LanguageWithCountriesFragment on Language {
  id
  languageCode
  languageTag
  countryCode
  name
  shortName
  shortNameEng
  countries {
    id
    name
    countryCode
  }
}
    `;
export const UserFragment = gql`
    fragment UserFragment on User {
  user_id
  email
  name
  picture
  permissions
}
    `;
export const MediaItemFragment = gql`
    fragment MediaItemFragment on MediaItem {
  id
  checksum
  metadata
  mimetype
  url
  name
  alt
  createdAt
  createdBy {
    ...UserFragment
  }
  network {
    id
  }
  tags {
    id
    name
  }
}
    ${UserFragment}`;
export const SiteFragment = gql`
    fragment SiteFragment on Site {
  id
  url
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  vertical {
    id
  }
  properties {
    ...PropertyItemFragment
  }
  content(where: {status: {in: [APPROVED, DRAFT]}}) {
    ...ContentItemFragment
  }
  language {
    ...LanguageFragment
  }
  parent {
    id
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}
${LanguageFragment}`;
export const VerticalFragment = gql`
    fragment VerticalFragment on Vertical {
  id
  network {
    id
  }
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  createdAt
  sites {
    ...SiteFragment
  }
  content {
    ...ContentItemFragment
  }
  properties {
    ...PropertyItemFragment
  }
}
    ${SiteFragment}
${ContentItemFragment}
${PropertyItemFragment}`;
export const MenuItemFragment = gql`
    fragment MenuItemFragment on MenuItem {
  id
  type
  index
  properties {
    ...PropertyItemFragment
  }
  content {
    ...ContentItemFragment
  }
  children {
    id
    type
    properties {
      ...PropertyItemFragment
    }
    content {
      ...ContentItemFragment
    }
  }
  parent {
    id
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const MenuFragment = gql`
    fragment MenuFragment on Menu {
  id
  key
  vertical {
    ...VerticalFragment
  }
  items {
    ...MenuItemFragment
  }
}
    ${VerticalFragment}
${MenuItemFragment}`;
export const NetworkFragment = gql`
    fragment NetworkFragment on Network {
  id
  companyId
  company {
    id
    name
    slug
  }
  createdAt
  updatedAt
  createdBy {
    ...UserFragment
  }
  verticals {
    ...VerticalFragment
  }
  content {
    ...ContentItemFragment
  }
  properties {
    ...PropertyItemFragment
  }
}
    ${UserFragment}
${VerticalFragment}
${ContentItemFragment}
${PropertyItemFragment}`;
export const PostStatusFragment = gql`
    fragment PostStatusFragment on Post {
  id
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  properties {
    ...PropertyItemFragment
  }
  content {
    ...ContentItemFragment
  }
  vertical {
    id
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const ProductFragment = gql`
    fragment ProductFragment on Product {
  id
  subtype
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  properties {
    ...PropertyItemFragment
  }
  content {
    ...ContentItemFragment
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const ProviderFragment = gql`
    fragment ProviderFragment on Provider {
  id
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  properties {
    ...PropertyItemFragment
  }
  content {
    ...ContentItemFragment
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const TaxonomyItemFragment = gql`
    fragment TaxonomyItemFragment on TaxonomyItem {
  id
  subtype
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  parent {
    id
  }
  properties {
    ...PropertyItemFragment
  }
  content {
    ...ContentItemFragment
  }
  network {
    id
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const AuthorCrudFragment = gql`
    fragment AuthorCrudFragment on Author {
  id
  resourceType
  createdAt
  createdBy {
    user_id
    name
  }
  updatedAt
  data
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
  ) {
    ...ContentItemFragment
  }
  properties(
    where: {contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}}
  ) {
    ...PropertyItemFragment
  }
}
    ${ContentItemFragment}
${PropertyItemFragment}`;
export const CompanyFragment = gql`
    fragment CompanyFragment on Company {
  id
  name
  slug
  createdAt
  updatedAt
  networks {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED]}}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const FilterTaxonomyItemCrudFragment = gql`
    fragment FilterTaxonomyItemCrudFragment on FilterTaxonomyItem {
  id
  subtype
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  network {
    id
  }
  properties(
    where: {contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}}
  ) {
    ...PropertyItemFragment
  }
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
    orderBy: {status: asc}
  ) {
    ...ContentItemFragment
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const MetaFilterTaxonomyRuleNewFragment = gql`
    fragment MetaFilterTaxonomyRuleNewFragment on FilterTaxonomyRule {
  id
  taxonomyBase {
    id
  }
  taxonomyFilter {
    id
    content(
      where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const NetworkCrudFragment = gql`
    fragment NetworkCrudFragment on Network {
  id
  companyId
  company {
    id
    name
    slug
  }
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  properties {
    ...PropertyItemFragment
  }
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, status: {in: [APPROVED, DRAFT]}}
    orderBy: {status: asc}
  ) {
    ...ContentItemFragment
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const PageCrudFragment = gql`
    fragment PageCrudFragment on Page {
  id
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  vertical {
    id
  }
  properties(
    where: {contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}}
  ) {
    ...PropertyItemFragment
  }
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
    orderBy: {status: asc}
  ) {
    id
    key
    translationType
    field {
      id
      key
      context
      type
    }
    ...ContentItemFragment
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const PostCrudFragment = gql`
    fragment PostCrudFragment on Post {
  id
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  vertical {
    id
  }
  properties(
    where: {contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}}
  ) {
    ...PropertyItemFragment
  }
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
    orderBy: {status: asc}
  ) {
    id
    key
    translationType
    field {
      id
      key
      context
      type
    }
    ...ContentItemFragment
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const ProductCrudFragment = gql`
    fragment ProductCrudFragment on Product {
  id
  subtype
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  network {
    id
  }
  properties(
    where: {contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}}
  ) {
    ...PropertyItemFragment
  }
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
    orderBy: {status: asc}
  ) {
    ...ContentItemFragment
  }
  pools {
    id
    networks {
      id
    }
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const ProviderCrudFragment = gql`
    fragment ProviderCrudFragment on Provider {
  id
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  pools {
    id
  }
  properties(
    where: {contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}}
  ) {
    ...PropertyItemFragment
  }
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
    orderBy: {status: asc}
  ) {
    ...ContentItemFragment
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const TaxonomyItemCrudFragment = gql`
    fragment TaxonomyItemCrudFragment on TaxonomyItem {
  id
  subtype
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  parent {
    id
  }
  network {
    id
  }
  properties(
    where: {contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}}
  ) {
    ...PropertyItemFragment
  }
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
    orderBy: {status: asc}
  ) {
    ...ContentItemFragment
  }
  pools {
    id
    networks {
      id
    }
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const VerticalCrudFragment = gql`
    fragment VerticalCrudFragment on Vertical {
  id
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  network {
    id
  }
  sites {
    ...SiteFragment
  }
  properties(where: {contextId: {equals: $currentNetworkId}}) {
    ...PropertyItemFragment
  }
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, contextId: {equals: $currentNetworkId}, status: {in: [APPROVED, DRAFT]}}
    orderBy: {status: asc}
  ) {
    ...ContentItemFragment
  }
}
    ${SiteFragment}
${PropertyItemFragment}
${ContentItemFragment}`;
export const ShortcodePages = gql`
    query ShortcodePages($verticalId: String, $defaultLanguageId: String!) {
  pages(where: {verticalId: {equals: $verticalId}}) {
    id
    vertical {
      id
    }
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {equals: "published"}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragment}`;
export const ShortcodePosts = gql`
    query ShortcodePosts($verticalId: String, $defaultLanguageId: String!) {
  posts(where: {verticalId: {equals: $verticalId}}) {
    id
    vertical {
      id
    }
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {equals: "published"}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragment}`;
export const ShortcodeProviders = gql`
    query ShortcodeProviders($where: RouteResourceWhereInput, $defaultLanguageId: String!) {
  providers(where: $where) {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {in: ["published", "verticals"]}}) {
      id
      key
      data
      contextId
    }
  }
}
    ${ContentItemFragment}`;
export const DuplicatedPage = gql`
    query DuplicatedPage($where: RouteResourceWhereInput) {
  pages(where: $where) {
    id
    vertical {
      id
    }
  }
}
    `;
export const DuplicatedPost = gql`
    query DuplicatedPost($where: RouteResourceWhereInput) {
  posts(where: $where) {
    id
    vertical {
      id
    }
  }
}
    `;
export const ProviderInputData = gql`
    query ProviderInputData($languageId: String!, $where: RouteResourceWhereInput) {
  providers(where: $where) {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $languageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {equals: "published"}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragment}`;
export const FilteredTaxonomyItemsInput = gql`
    query FilteredTaxonomyItemsInput($where: RouteResourceWhereInput!, $defaultLanguageId: String!) {
  taxonomyItems(where: $where) {
    id
    parentId
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const TaxonomyParentItemsInput = gql`
    query TaxonomyParentItemsInput($where: RouteResourceWhereInput!, $defaultLanguageId: String!) {
  taxonomyItems(where: $where) {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const DynamicFormInputPropertyResource = gql`
    query DynamicFormInputPropertyResource($languageId: String!, $taxonomyItemsWhere: RouteResourceWhereInput, $providersWhere: RouteResourceWhereInput) {
  providers(where: $providersWhere) {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $languageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {equals: "published"}}) {
      id
      key
      data
    }
  }
  taxonomyItems(where: $taxonomyItemsWhere) {
    id
    parentId
    content(
      where: {key: {equals: "name"}, languageId: {equals: $languageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {equals: "published"}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragment}`;
export const PropertyItems = gql`
    query PropertyItems($where: PropertyItemWhereInput) {
  propertyItems(where: $where) {
    ...PropertyItemFragment
  }
}
    ${PropertyItemFragment}`;
export const GroupTaxonomyItems = gql`
    query GroupTaxonomyItems($languageId: String!, $where: RouteResourceWhereInput) {
  taxonomyItems(where: $where) {
    id
    parentId
    subtype
    content(
      where: {key: {equals: "name"}, languageId: {equals: $languageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {in: ["published", "icon"]}}) {
      id
      key
      data
      resolvedData {
        ... on MediaItem {
          url
        }
      }
    }
  }
}
    ${ContentItemFragment}`;
export const PillarSections = gql`
    query PillarSections($where: RouteResourceWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  pages(where: $where, take: $take, skip: $skip) {
    id
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {equals: "parent"}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragment}`;
export const NetworksVerticalsSites = gql`
    query NetworksVerticalsSites($defaultLanguageId: String!) {
  networks {
    id
    verticals {
      id
      content(
        where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
        orderBy: {status: asc}
        take: 1
      ) {
        ...ContentItemFragment
      }
      sites {
        id
        url
      }
    }
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
  countries {
    id
    name
    countryCode
  }
}
    ${ContentItemFragment}`;
export const CreateTranslationJob = gql`
    mutation CreateTranslationJob($jobs: [TranslationJobData!]!) {
  createTranslationJobs(jobs: $jobs) {
    id
    data
    timestamp
  }
}
    `;
export const SitesForLocalization = gql`
    query SitesForLocalization($where: SiteWhereInput, $take: Int, $skip: Int) {
  sites(where: $where, take: $take, skip: $skip) {
    id
    properties(where: {key: {in: ["country", "global", "language"]}}) {
      id
      key
      data
    }
  }
  count: siteCount(where: $where)
}
    `;
export const DeleteContentItem = gql`
    mutation DeleteContentItem($where: ContentItemWhereUniqueInput!) {
  deleteContentItem(where: $where) {
    id
  }
}
    `;
export const DeleteFile = gql`
    mutation DeleteFile($where: MediaItemWhereUniqueInput) {
  deleteFile(where: $where) {
    id
  }
}
    `;
export const UploadFile = gql`
    mutation UploadFile($file: Upload!, $networkId: String!) {
  uploadFile(file: $file, networkId: $networkId) {
    ...MediaItemFragment
  }
}
    ${MediaItemFragment}`;
export const UploadFileWithCloudinaryWidget = gql`
    mutation UploadFileWithCloudinaryWidget($networkId: String, $cloudinaryFileObject: CloudinaryFileInput!) {
  uploadFileWithCloudinaryWidget(
    networkId: $networkId
    cloudinaryFileObject: $cloudinaryFileObject
  ) {
    ...MediaItemFragment
  }
}
    ${MediaItemFragment}`;
export const UploadFileWithUrl = gql`
    mutation UploadFileWithURL($url: String!, $networkId: String!, $tags: [String]) {
  uploadFileWithURL(url: $url, networkId: $networkId, tags: $tags) {
    ...MediaItemFragment
  }
}
    ${MediaItemFragment}`;
export const UploadImage = gql`
    mutation UploadImage($file: Upload!, $networkId: String!) {
  uploadFile(file: $file, networkId: $networkId) {
    url
  }
}
    `;
export const CreateRedirect = gql`
    mutation CreateRedirect($data: RedirectCreateInput!) {
  createRedirect(data: $data) {
    id
    httpCode
    scope
    sourceKind
    sourcePath
    sourceUrl
    sourceResourceType
    sourceResourceId
    sourceSiteId
    sourceVerticalId
    sourceNetworkId
    targetKind
    targetPath
    targetUrl
    targetResourceType
    targetResourceId
    targetSiteId
    targetVerticalId
    targetNetworkId
    createdAt
    updatedAt
    createdBy {
      user_id
      email
    }
  }
}
    `;
export const DeleteRedirect = gql`
    mutation DeleteRedirect($where: RedirectWhereUniqueInput!) {
  deleteRedirect(where: $where) {
    id
  }
}
    `;
export const UpsertRedirect = gql`
    mutation UpsertRedirect($where: RedirectWhereUniqueInput!, $create: RedirectCreateInput!, $update: RedirectUpdateInput!) {
  upsertRedirect(where: $where, create: $create, update: $update) {
    id
    httpCode
    scope
    sourceKind
    sourcePath
    sourceUrl
    sourceResourceType
    sourceResourceId
    sourceSiteId
    sourceVerticalId
    sourceNetworkId
    targetKind
    targetPath
    targetUrl
    targetResourceType
    targetResourceId
    targetSiteId
    targetVerticalId
    targetNetworkId
    createdAt
    updatedAt
    createdBy {
      user_id
      email
    }
  }
}
    `;
export const UpsertProduct = gql`
    mutation UpsertProduct($where: RouteResourceWhereUniqueInput!, $data: ProductUpsertDataInput!, $current: ResourceCurrentInput!) {
  upsertProduct(where: $where, data: $data, current: $current) {
    ...ProductFragment
  }
}
    ${ProductFragment}`;
export const UpsertProvider = gql`
    mutation UpsertProvider($where: RouteResourceWhereUniqueInput!, $data: ProviderUpsertDataInput!, $current: ResourceCurrentInput!) {
  upsertProvider(where: $where, data: $data, current: $current) {
    id
  }
}
    `;
export const UpsertTaxonomyItem = gql`
    mutation UpsertTaxonomyItem($where: RouteResourceWhereUniqueInput!, $data: TaxonomyItemUpsertDataInput!, $current: ResourceCurrentInput!) {
  upsertTaxonomyItem(where: $where, data: $data, current: $current) {
    ...TaxonomyItemFragment
  }
}
    ${TaxonomyItemFragment}`;
export const UpsertPostStatus = gql`
    mutation UpsertPostStatus($where: RouteResourceWhereUniqueInput!, $data: PostUpsertDataInput!, $current: ResourceCurrentInput!) {
  upsertPost(where: $where, data: $data, current: $current) {
    ...PostStatusFragment
  }
}
    ${PostStatusFragment}`;
export const UpsertSite = gql`
    mutation UpsertSite($where: SiteWhereUniqueInput!, $data: SiteUpsertDataInput!, $current: SiteCurrentInput!) {
  upsertSite(where: $where, data: $data, current: $current) {
    ...SiteFragment
  }
}
    ${SiteFragment}`;
export const UpdateMediaItem = gql`
    mutation UpdateMediaItem($where: MediaItemWhereUniqueInput!, $data: MediaItemUpdateInput!) {
  updateMediaItem(where: $where, data: $data) {
    id
  }
}
    `;
export const AllTaxonomyItems = gql`
    query AllTaxonomyItems($where: RouteResourceWhereInput, $languageId: String!) {
  taxonomyItems(where: $where) {
    id
    parentId
    subtype
    content(
      where: {key: {equals: "name"}, languageId: {equals: $languageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {in: ["published", "icon", "verticals"]}}) {
      id
      key
      data
      contextId
      resolvedData {
        ... on MediaItem {
          url
        }
      }
    }
    pools {
      id
      networks {
        id
      }
    }
  }
}
    ${ContentItemFragment}`;
export const AllTemplates = gql`
    query AllTemplates($where: TemplateWhereInput!) {
  templates(where: $where) {
    id
    type
    subtype
    network {
      id
    }
    content {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const Authors = gql`
    query Authors($where: RouteResourceWhereInput, $take: Int, $skip: Int) {
  authors(where: $where, take: $take, skip: $skip) {
    id
    properties {
      id
      key
      data
    }
  }
  count: authorCount(where: $where)
}
    `;
export const Countries = gql`
    query Countries($where: CountryWhereInput) {
  countries(where: $where) {
    ...CountryFragment
  }
}
    ${CountryFragment}`;
export const CountriesWithLanguages = gql`
    query CountriesWithLanguages($where: CountryWhereInput) {
  countries(where: $where) {
    ...CountryWithLanguagesFragment
  }
}
    ${CountryWithLanguagesFragment}`;
export const FilterTaxonomyRules = gql`
    query FilterTaxonomyRules($where: FilterTaxonomyRuleWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  filterTaxonomyRules(where: $where, take: $take, skip: $skip) {
    id
    taxonomyBase {
      id
      content(
        where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
        orderBy: {status: asc}
        take: 1
      ) {
        ...ContentItemFragment
      }
    }
    taxonomyFilter {
      id
      content(
        where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
        orderBy: {status: asc}
        take: 1
      ) {
        ...ContentItemFragment
      }
    }
  }
  count: filterTaxonomyRuleCount(where: $where)
}
    ${ContentItemFragment}`;
export const Languages = gql`
    query Languages($where: LanguageWhereInput) {
  languages(where: $where) {
    ...LanguageFragment
  }
}
    ${LanguageFragment}`;
export const LanguagesWithCountries = gql`
    query LanguagesWithCountries($where: LanguageWhereInput) {
  languages(where: $where) {
    ...LanguageWithCountriesFragment
  }
}
    ${LanguageWithCountriesFragment}`;
export const Me = gql`
    query Me {
  me {
    ...UserFragment
  }
}
    ${UserFragment}`;
export const MediaItem = gql`
    query MediaItem($where: MediaItemWhereUniqueInput!) {
  mediaItem(where: $where) {
    ...MediaItemFragment
  }
}
    ${MediaItemFragment}`;
export const MediaItems = gql`
    query MediaItems($where: MediaItemWhereInput, $take: Int, $skip: Int, $orderBy: [MediaItemOrderByWithRelationInput!]) {
  mediaItems(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    ...MediaItemFragment
  }
  count: mediaItemCount(where: $where)
}
    ${MediaItemFragment}`;
export const Networks = gql`
    query Networks($where: NetworkWhereInput, $take: Int, $skip: Int) {
  networks(where: $where, take: $take, skip: $skip) {
    ...NetworkFragment
  }
  count: networkCount(where: $where)
}
    ${NetworkFragment}`;
export const NetworksSlim = gql`
    query NetworksSlim($where: NetworkWhereInput, $take: Int, $skip: Int, $orderBy: [NetworkOrderByWithRelationInput!], $defaultLanguageId: String!) {
  networks(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    id
    companyId
    company {
      id
      name
      slug
    }
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED]}}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const Pages = gql`
    query Pages($where: RouteResourceWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  pages(where: $where, take: $take, skip: $skip) {
    id
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {in: ["published", "parent"]}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragment}`;
export const Posts = gql`
    query Posts($where: RouteResourceWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  posts(where: $where, take: $take, skip: $skip) {
    id
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {in: ["published", "parent"]}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragment}`;
export const ProductPools = gql`
    query ProductPools($where: RouteResourcePoolWhereInput) {
  productPools(where: $where) {
    id
    name
    networks {
      id
    }
    products {
      id
    }
  }
}
    `;
export const Products = gql`
    query Products($where: RouteResourceWhereInput, $take: Int, $skip: Int) {
  products(where: $where, take: $take, skip: $skip) {
    ...ProductFragment
  }
  count: productCount(where: $where)
}
    ${ProductFragment}`;
export const ProductsForStore = gql`
    query ProductsForStore($where: RouteResourceWhereInput, $defaultLanguageId: String!) {
  products(where: $where) {
    id
    subtype
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(
      where: {key: {in: ["published", "software-taxonomies", "verticals"]}}
    ) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragment}`;
export const Provider = gql`
    query Provider($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!) {
  provider(where: $where) {
    id
    content(
      where: {languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const ProviderPools = gql`
    query ProviderPools($where: RouteResourcePoolWhereInput) {
  providerPools(where: $where) {
    id
    name
    networks {
      id
    }
    providers {
      id
    }
  }
}
    `;
export const Providers = gql`
    query Providers($where: RouteResourceWhereInput, $take: Int, $skip: Int) {
  providers(where: $where, take: $take, skip: $skip) {
    ...ProviderFragment
  }
  count: providerCount(where: $where)
}
    ${ProviderFragment}`;
export const ProvidersAndTaxonomiesCounts = gql`
    query ProvidersAndTaxonomiesCounts($networkId: String) {
  newResourceCounts(networkId: $networkId) {
    providersCount
    taxonomyItemsCount
  }
}
    `;
export const RankingProviders = gql`
    query RankingProviders($where: RouteResourceWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  providers(where: $where, take: $take, skip: $skip) {
    id
    properties(
      where: {OR: [{key: {in: ["logotype", "published", "calculated-restricted-countries", "suspended", "verticals"]}}, {type: {equals: TAXONOMYITEM}}]}
    ) {
      id
      key
      data
      type
    }
    content(
      where: {key: {in: ["name", "bonus-text"]}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const Redirects = gql`
    query Redirects($where: RedirectWhereInput, $orderBy: [RedirectOrderByWithRelationInput!], $skip: Int, $take: Int, $defaultLanguageId: String!) {
  redirects(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
    id
    httpCode
    scope
    sourceKind
    sourcePath
    sourceUrl
    sourceResourceType
    sourceResourceId
    sourceResource {
      id
      resourceType
      content(
        where: {key: {in: ["title", "name"]}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
        orderBy: {status: asc}
        take: 1
      ) {
        ...ContentItemFragment
      }
    }
    sourceSiteId
    sourceVerticalId
    sourceNetworkId
    targetKind
    targetPath
    targetUrl
    targetResourceType
    targetResourceId
    targetResource {
      id
      resourceType
      content(
        where: {key: {in: ["title", "name"]}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
        orderBy: {status: asc}
        take: 1
      ) {
        ...ContentItemFragment
      }
    }
    targetSiteId
    targetVerticalId
    targetNetworkId
    createdAt
    updatedAt
    createdBy {
      user_id
      email
    }
  }
}
    ${ContentItemFragment}`;
export const RedirectCount = gql`
    query RedirectCount($where: RedirectWhereInput) {
  redirectCount(where: $where)
}
    `;
export const Redirect = gql`
    query Redirect($where: RedirectWhereUniqueInput!) {
  redirect(where: $where) {
    id
    httpCode
    scope
    sourceKind
    sourcePath
    sourceUrl
    sourceResourceType
    sourceResourceId
    sourceSiteId
    sourceVerticalId
    sourceNetworkId
    targetKind
    targetPath
    targetUrl
    targetResourceType
    targetResourceId
    targetSiteId
    targetVerticalId
    targetNetworkId
    createdAt
    updatedAt
    createdBy {
      user_id
      email
    }
  }
}
    `;
export const RegionsSubregionsCountries = gql`
    query RegionsSubregionsCountries($where: RegionWhereInput) {
  regions(where: $where) {
    id
    name
    subregions {
      id
      name
      countries {
        countryCode
        id
        name
      }
    }
  }
}
    `;
export const SchedulerPosts = gql`
    query SchedulerPosts($where: RouteResourceWhereInput, $take: Int, $skip: Int, $currentLanguageId: String!) {
  posts(where: $where, take: $take, skip: $skip) {
    id
    createdAt
    publishedAt
    properties(where: {key: {in: ["published-at", "published"]}}) {
      id
      key
      data
    }
    content(
      where: {key: {equals: "title"}, languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
  count: postCount(where: $where)
}
    ${ContentItemFragment}`;
export const Sites = gql`
    query Sites($where: SiteWhereInput, $take: Int, $skip: Int) {
  sites(where: $where, take: $take, skip: $skip) {
    id
    url
    vertical {
      id
    }
  }
  count: siteCount(where: $where)
}
    `;
export const SitesSlim = gql`
    query SitesSlim($where: SiteWhereInput, $take: Int, $skip: Int) {
  sites(where: $where, take: $take, skip: $skip) {
    id
    url
    properties(where: {key: {in: ["name", "global", "country"]}}) {
      id
      key
      data
    }
    language {
      id
      languageCode
      languageTag
      countryCode
    }
  }
  count: siteCount(where: $where)
}
    `;
export const StringTemplateVariables = gql`
    query StringTemplateVariables($where: StringTemplateVariableWhereInput) {
  stringTemplateVariables(where: $where) {
    id
    type
    key
    name
    group
    data
  }
}
    `;
export const Tags = gql`
    query Tags($take: Int, $orderBy: [TagOrderByWithRelationInput!], $where: TagWhereInput) {
  tags(take: $take, orderBy: $orderBy, where: $where) {
    name
    id
  }
}
    `;
export const TaxonomyItemPools = gql`
    query TaxonomyItemPools($where: RouteResourcePoolWhereInput) {
  taxonomyItemPools(where: $where) {
    id
    name
    networks {
      id
    }
    taxonomyItems {
      id
    }
  }
}
    `;
export const Templates = gql`
    query Templates($where: TemplateWhereInput!) {
  templates(where: $where) {
    id
    type
    subtype
    network {
      id
    }
    content(
      where: {languageId: {equals: "cka2r9yww001164rm5rp69iko"}, status: {equals: APPROVED}}
    ) {
      ...ContentItemFragment
    }
    fields {
      id
      required
      index
      group
      key
      type
      hidden
      list
      geo
      data
      context
      resourceType
      defaultTranslationType
      displayType
      content(
        where: {languageId: {equals: "cka2r9yww001164rm5rp69iko"}, status: {equals: APPROVED}}
      ) {
        ...ContentItemFragment
      }
    }
    groups {
      id
      name
      index
      extended
      generalGroup {
        id
        name
        index
      }
      data
    }
  }
}
    ${ContentItemFragment}`;
export const TranslationJobsEstimatedCost = gql`
    query TranslationJobsEstimatedCost($jobs: [TranslationJobData!]!) {
  translationJobsEstimatedCost(jobs: $jobs)
}
    `;
export const User = gql`
    query User($id: String!) {
  user(id: $id) {
    app_metadata
    ...UserFragment
  }
}
    ${UserFragment}`;
export const Users = gql`
    query Users {
  users {
    app_metadata
    ...UserFragment
  }
}
    ${UserFragment}`;
export const Verticals = gql`
    query Verticals($where: VerticalWhereInput, $take: Int, $skip: Int, $orderBy: [VerticalOrderByWithRelationInput!], $defaultLanguageId: String!) {
  verticals(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    id
    createdAt
    sites {
      id
      url
      language {
        id
        languageTag
        countryCode
      }
    }
    content(
      where: {status: {in: [APPROVED, DRAFT]}, languageId: {equals: $defaultLanguageId}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
  count: verticalCount(where: $where)
}
    ${ContentItemFragment}`;
export const VerticalsSlim = gql`
    query VerticalsSlim($where: VerticalWhereInput, $take: Int, $skip: Int, $orderBy: [VerticalOrderByWithRelationInput!], $defaultLanguageId: String!) {
  verticals(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    id
    network {
      id
    }
    content(
      where: {key: {in: ["name", "abbreviated-name"]}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED]}}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const DeleteAuthor = gql`
    mutation DeleteAuthor($where: RouteResourceWhereUniqueInput!) {
  deleteAuthor(where: $where) {
    id
  }
}
    `;
export const Author = gql`
    query Author($where: RouteResourceWhereUniqueInput!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!, $currentLanguageId: String!, $defaultLanguageId: String!) {
  author(where: $where) {
    ...AuthorCrudFragment
  }
}
    ${AuthorCrudFragment}`;
export const DynamicListAuthors = gql`
    query DynamicListAuthors($where: RouteResourceWhereInput, $search: RouteResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [RouteResourceOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput) {
  count: authorsSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  authors: authorsSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    createdAt
    updatedAt
    createdBy {
      user_id
      name
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(where: {key: {in: $contentKeys}}) {
      ...ContentItemFragment
    }
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const UpsertAuthor = gql`
    mutation UpsertAuthor($where: RouteResourceWhereUniqueInput!, $data: AuthorUpsertDataInput!, $current: ResourceCurrentInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  upsertAuthor(where: $where, data: $data, current: $current) {
    ...AuthorCrudFragment
  }
}
    ${AuthorCrudFragment}`;
export const Companies = gql`
    query Companies($where: CompanyWhereInput, $take: Int, $skip: Int, $orderBy: [CompanyOrderByWithRelationInput!], $defaultLanguageId: String!) {
  companies(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    ...CompanyFragment
  }
}
    ${CompanyFragment}`;
export const Company = gql`
    query Company($where: CompanyWhereUniqueInput!, $defaultLanguageId: String!) {
  company(where: $where) {
    ...CompanyFragment
  }
}
    ${CompanyFragment}`;
export const UpsertCompany = gql`
    mutation UpsertCompany($where: CompanyWhereUniqueInput!, $create: CompanyCreateInput!, $update: CompanyUpdateInput!, $defaultLanguageId: String!) {
  upsertCompany(where: $where, create: $create, update: $update) {
    ...CompanyFragment
  }
}
    ${CompanyFragment}`;
export const ComplianceRules = gql`
    query ComplianceRules($networkId: String!) {
  complianceRules: propertyItems(
    where: {key: {equals: "compliance-rules"}, Network: {id: {equals: $networkId}}}
  ) {
    ...PropertyItemFragment
  }
}
    ${PropertyItemFragment}`;
export const UpdatePropertyItem = gql`
    mutation UpdatePropertyItem($where: PropertyItemWhereUniqueInput!, $data: PropertyItemUpdateInput!) {
  updatePropertyItem(where: $where, data: $data) {
    ...PropertyItemFragment
  }
}
    ${PropertyItemFragment}`;
export const AuthorsForExport = gql`
    query AuthorsForExport($where: RouteResourceWhereInput) {
  resources: authors(where: $where) {
    id
    properties(where: {key: {equals: "name"}}) {
      id
      key
      data
    }
  }
}
    `;
export const FilterTaxonomyItemsForExport = gql`
    query filterTaxonomyItemsForExport($where: RouteResourceWhereInput, $defaultLanguageId: String!) {
  resources: filterTaxonomyItems(where: $where) {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const PagesForExport = gql`
    query pagesForExport($where: RouteResourceWhereInput, $defaultLanguageId: String!) {
  resources: pages(where: $where) {
    id
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const PostsForExport = gql`
    query postsForExport($where: RouteResourceWhereInput, $defaultLanguageId: String!) {
  resources: posts(where: $where) {
    id
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const ProductsForExport = gql`
    query productsForExport($where: RouteResourceWhereInput, $defaultLanguageId: String!) {
  resources: products(where: $where) {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {equals: "software-taxonomies"}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragment}`;
export const ProviderTaxonomyConnectionsForExport = gql`
    query ProviderTaxonomyConnectionsForExport($where: ProviderTaxonomyConnectionWhereInput) {
  resources: providerTaxonomyConnections(where: $where) {
    id
    providerId
    taxonomyItemId
  }
}
    `;
export const ProvidersForExport = gql`
    query ProvidersForExport($where: RouteResourceWhereInput, $defaultLanguageId: String!) {
  resources: providers(where: $where) {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {in: ["published"]}}) {
      key
      data
    }
  }
}
    ${ContentItemFragment}`;
export const SitesForExport = gql`
    query sitesForExport($where: SiteWhereInput) {
  resources: sites(where: $where) {
    id
    properties(where: {key: {equals: "name"}}) {
      id
      key
      data
    }
  }
}
    `;
export const DeleteFilterTaxonomyItem = gql`
    mutation DeleteFilterTaxonomyItem($where: RouteResourceWhereUniqueInput!) {
  deleteFilterTaxonomyItem(where: $where) {
    id
  }
}
    `;
export const FilterTaxonomyItem = gql`
    query FilterTaxonomyItem($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  filterTaxonomyItem(where: $where) {
    ...FilterTaxonomyItemCrudFragment
  }
}
    ${FilterTaxonomyItemCrudFragment}`;
export const DynamicListFilterTaxonomyItems = gql`
    query DynamicListFilterTaxonomyItems($where: RouteResourceWhereInput, $search: RouteResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [RouteResourceOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput) {
  count: filterTaxonomyItemsSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  filterTaxonomyItems: filterTaxonomyItemsSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    subtype
    createdAt
    updatedAt
    createdBy {
      user_id
      name
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(where: {key: {in: $contentKeys}}) {
      ...ContentItemFragment
    }
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const UpsertFilterTaxonomyItem = gql`
    mutation UpsertFilterTaxonomyItem($where: RouteResourceWhereUniqueInput!, $data: FilterTaxonomyItemUpsertDataInput!, $current: ResourceCurrentInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  upsertFilterTaxonomyItem(where: $where, data: $data, current: $current) {
    ...FilterTaxonomyItemCrudFragment
  }
}
    ${FilterTaxonomyItemCrudFragment}`;
export const DeleteFilterTaxonomyRule = gql`
    mutation DeleteFilterTaxonomyRule($where: FilterTaxonomyRuleWhereUniqueInput!) {
  deleteFilterTaxonomyRule(where: $where) {
    id
  }
}
    `;
export const FilterTaxonomyRule = gql`
    query FilterTaxonomyRule($where: FilterTaxonomyRuleWhereUniqueInput!) {
  filterTaxonomyRule(where: $where) {
    ...FilterTaxonomyRuleFragment
  }
}
    ${FilterTaxonomyRuleFragment}`;
export const DynamicListFilterTaxonomyRules = gql`
    query DynamicListFilterTaxonomyRules($where: FilterTaxonomyRuleWhereInput, $search: ResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [FilterTaxonomyRuleOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput) {
  count: filterTaxonomyRulesSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  filterTaxonomyRules: filterTaxonomyRulesSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    createdAt
    updatedAt
    createdBy {
      user_id
      name
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(where: {key: {in: $contentKeys}}) {
      ...ContentItemFragment
    }
    taxonomyBase {
      id
      content(where: {key: {in: $contentKeys}}) {
        ...ContentItemFragment
      }
    }
    taxonomyFilter {
      id
      content(where: {key: {in: $contentKeys}}) {
        ...ContentItemFragment
      }
    }
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const UpsertFilterTaxonomyRule = gql`
    mutation UpsertFilterTaxonomyRule($where: FilterTaxonomyRuleWhereUniqueInput!, $data: FilterTaxonomyRuleUpsertDataInput!, $current: ResourceCurrentInput!) {
  upsertFilterTaxonomyRule(where: $where, data: $data, current: $current) {
    ...FilterTaxonomyRuleFragment
  }
}
    ${FilterTaxonomyRuleFragment}`;
export const CreateOrUpdateMenu = gql`
    mutation CreateOrUpdateMenu($menu: MenuInput!, $menuItemsDelete: [String]) {
  upsertMenuCustom(menu: $menu, menuItemsDelete: $menuItemsDelete) {
    id
  }
}
    `;
export const DeleteMenu = gql`
    mutation DeleteMenu($where: MenuWhereUniqueInput!) {
  deleteMenu(where: $where) {
    id
  }
}
    `;
export const DeleteMenus = gql`
    mutation DeleteMenus($where: MenuWhereInput!) {
  deleteMenus(where: $where) {
    count
  }
}
    `;
export const LoadMenus = gql`
    query LoadMenus($where: MenuWhereInput, $currentLanguageId: String!) {
  menus(where: $where) {
    id
    key
    items {
      id
      type
      index
      properties {
        id
        key
        type
        data
      }
      content(
        where: {languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}}
        orderBy: {status: asc}
      ) {
        ...ContentItemFragment
      }
      parent {
        id
      }
    }
  }
}
    ${ContentItemFragment}`;
export const LoadMinifiedMenusWithSites = gql`
    query LoadMinifiedMenusWithSites($where: MenuWhereInput) {
  menus(where: $where) {
    id
    key
    site {
      id
      url
      properties(where: {key: {equals: "name"}}) {
        id
        key
        data
      }
      language {
        id
        countryCode
        languageTag
      }
    }
  }
}
    `;
export const MenuPages = gql`
    query MenuPages($where: RouteResourceWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  pages(where: $where, take: $take, skip: $skip) {
    id
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {in: ["published", "icon"]}}) {
      id
      key
      data
      resolvedData {
        ... on MediaItem {
          url
        }
      }
    }
  }
  count: pageCount(where: $where)
}
    ${ContentItemFragment}`;
export const MenuPosts = gql`
    query MenuPosts($where: RouteResourceWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  posts(where: $where, take: $take, skip: $skip) {
    id
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {in: ["published", "icon"]}}) {
      id
      key
      data
      resolvedData {
        ... on MediaItem {
          url
        }
      }
    }
  }
  count: postCount(where: $where)
}
    ${ContentItemFragment}`;
export const MenuProviders = gql`
    query MenuProviders($where: RouteResourceWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  providers(where: $where, take: $take, skip: $skip) {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {equals: "published"}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragment}`;
export const AllSitesInNetwork = gql`
    query AllSitesInNetwork($where: SiteWhereInput, $take: Int, $skip: Int) {
  sites(where: $where, take: $take, skip: $skip) {
    id
    language {
      id
      languageTag
    }
  }
}
    `;
export const MetaProduct = gql`
    query MetaProduct($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!) {
  product(where: $where) {
    id
    subtype
    content(
      where: {OR: [{field: {displayType: {in: [META, UI]}}}, {field: {key: {equals: "name"}}}], languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const MetaProducts = gql`
    query MetaProducts($where: RouteResourceWhereInput, $take: Int, $skip: Int, $currentLanguageId: String!, $defaultLanguageId: String!) {
  products(where: $where, take: $take, skip: $skip) {
    id
    content(
      where: {key: {in: ["name", "title"]}, languageId: {in: [$currentLanguageId, $defaultLanguageId]}, status: {in: [APPROVED]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const MetaProvider = gql`
    query MetaProvider($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!) {
  provider(where: $where) {
    id
    content(
      where: {OR: [{field: {displayType: {in: [META, UI]}}}, {field: {key: {equals: "name"}}}], languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const MetaProviders = gql`
    query MetaProviders($where: RouteResourceWhereInput, $take: Int, $skip: Int, $currentLanguageId: String!, $defaultLanguageId: String!) {
  providers(where: $where, take: $take, skip: $skip) {
    id
    content(
      where: {OR: [{key: {equals: "name"}}, {key: {equals: "title"}}], languageId: {in: [$currentLanguageId, $defaultLanguageId]}, status: {in: [APPROVED]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const MetaFilterTaxonomyRules = gql`
    query MetaFilterTaxonomyRules($where: FilterTaxonomyRuleWhereInput, $take: Int, $skip: Int, $currentLanguageId: String!, $defaultLanguageId: String!) {
  filterTaxonomyRules(where: $where, take: $take, skip: $skip) {
    ...MetaFilterTaxonomyRuleNewFragment
  }
  count: filterTaxonomyRuleCount(where: $where)
}
    ${MetaFilterTaxonomyRuleNewFragment}`;
export const MetaTaxonomyItem = gql`
    query MetaTaxonomyItem($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!) {
  taxonomyItem(where: $where) {
    id
    parent {
      id
      content(
        where: {languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}, OR: [{field: {displayType: {in: [META, UI]}}}, {field: {key: {equals: "name"}}}]}
        orderBy: {status: asc}
      ) {
        ...ContentItemFragment
      }
    }
    content(
      where: {languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}, OR: [{field: {displayType: {in: [META, UI]}}}, {field: {key: {equals: "name"}}}]}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const MetaTaxonomyItems = gql`
    query MetaTaxonomyItems($where: RouteResourceWhereInput, $take: Int, $skip: Int, $currentLanguageId: String!, $defaultLanguageId: String!) {
  taxonomyItems(where: $where, take: $take, skip: $skip) {
    id
    parent {
      id
    }
    subtype
    parentId
    content(
      where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, status: {in: [APPROVED]}, OR: [{key: {equals: "name"}}, {key: {equals: "title"}}]}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const StringTemplates = gql`
    query StringTemplates($where: StringTemplateWhereInput, $take: Int, $skip: Int, $currentLanguageId: String!, $defaultLanguageId: String!) {
  stringTemplates(where: $where, take: $take, skip: $skip) {
    id
    key
    level
    content(
      where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, status: {equals: APPROVED}}
    ) {
      ...ContentItemFragment
    }
    properties {
      ...PropertyItemFragment
    }
  }
}
    ${ContentItemFragment}
${PropertyItemFragment}`;
export const UpsertStringTemplate = gql`
    mutation UpsertStringTemplate($where: StringTemplateWhereUniqueInput!, $data: StringTemplateUpsertDataInput!, $current: ResourceCurrentInput!) {
  upsertStringTemplate(where: $where, data: $data, current: $current) {
    id
  }
}
    `;
export const DeleteNetwork = gql`
    mutation DeleteNetwork($where: NetworkWhereUniqueInput!) {
  deleteNetwork(where: $where) {
    id
  }
}
    `;
export const Network = gql`
    query Network($where: NetworkWhereUniqueInput!, $currentLanguageId: String!, $defaultLanguageId: String!) {
  network(where: $where) {
    ...NetworkCrudFragment
  }
}
    ${NetworkCrudFragment}`;
export const UpsertNetwork = gql`
    mutation UpsertNetwork($where: NetworkWhereUniqueInput!, $data: NetworkUpsertDataInput!, $currentLanguageId: String!, $defaultLanguageId: String!) {
  upsertNetwork(where: $where, data: $data) {
    ...NetworkCrudFragment
  }
}
    ${NetworkCrudFragment}`;
export const DeletePage = gql`
    mutation DeletePage($where: RouteResourceWhereUniqueInput!) {
  deletePage(where: $where) {
    id
  }
}
    `;
export const Page = gql`
    query Page($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  page(where: $where) {
    ...PageCrudFragment
  }
}
    ${PageCrudFragment}`;
export const UpsertPage = gql`
    mutation UpsertPage($where: RouteResourceWhereUniqueInput!, $data: PageUpsertDataInput!, $current: ResourceCurrentInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  upsertPage(where: $where, data: $data, current: $current) {
    ...PageCrudFragment
  }
}
    ${PageCrudFragment}`;
export const DynamicListPages = gql`
    query DynamicListPages($where: RouteResourceWhereInput, $search: RouteResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [RouteResourceOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput, $currentLanguageId: String!) {
  count: pagesSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  pages: pagesSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    createdAt
    updatedAt
    createdBy {
      user_id
      name
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(
      where: {key: {in: $contentKeys}, languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const DeletePost = gql`
    mutation DeletePost($where: RouteResourceWhereUniqueInput!) {
  deletePost(where: $where) {
    id
  }
}
    `;
export const Post = gql`
    query Post($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  post(where: $where) {
    ...PostCrudFragment
  }
}
    ${PostCrudFragment}`;
export const UpsertPost = gql`
    mutation UpsertPost($where: RouteResourceWhereUniqueInput!, $data: PostUpsertDataInput!, $current: ResourceCurrentInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  upsertPost(where: $where, data: $data, current: $current) {
    ...PostCrudFragment
  }
}
    ${PostCrudFragment}`;
export const DynamicListPosts = gql`
    query DynamicListPosts($where: RouteResourceWhereInput, $search: RouteResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [RouteResourceOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput, $currentLanguageId: String!) {
  count: postsSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  posts: postsSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    createdAt
    updatedAt
    createdBy {
      user_id
      name
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(
      where: {key: {in: $contentKeys}, languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const DeleteProduct = gql`
    mutation DeleteProduct($where: RouteResourceWhereUniqueInput!) {
  deleteProduct(where: $where) {
    id
  }
}
    `;
export const DeleteProductPool = gql`
    mutation DeleteProductPool($where: ProductPoolWhereUniqueInput!) {
  deleteProductPool(where: $where) {
    id
  }
}
    `;
export const Product = gql`
    query Product($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  product(where: $where) {
    ...ProductCrudFragment
  }
}
    ${ProductCrudFragment}`;
export const ProductPool = gql`
    query ProductPool($where: RouteResourcePoolWhereUniqueInput!) {
  productPool(where: $where) {
    id
    name
    networks {
      id
    }
    products {
      id
    }
  }
}
    `;
export const DynamicListProducts = gql`
    query DynamicListProducts($where: RouteResourceWhereInput, $search: RouteResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [RouteResourceOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput) {
  count: productsSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  products: productsSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    subtype
    createdAt
    updatedAt
    createdBy {
      user_id
      name
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(
      where: {key: {in: $contentKeys}, status: {in: [APPROVED, DRAFT]}, languageId: {equals: "cka2r9yww001164rm5rp69iko"}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
    pools {
      id
      networks {
        id
      }
    }
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const UpsertProductCrud = gql`
    mutation UpsertProductCrud($where: RouteResourceWhereUniqueInput!, $data: ProductUpsertDataInput!, $current: ResourceCurrentInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  upsertProduct(where: $where, data: $data, current: $current) {
    ...ProductCrudFragment
  }
}
    ${ProductCrudFragment}`;
export const UpsertProductPool = gql`
    mutation UpsertProductPool($where: RouteResourcePoolWhereUniqueInput, $data: RouteResourcePoolUpsertDataInput!) {
  upsertProductPool(where: $where, data: $data) {
    id
  }
}
    `;
export const ProviderOverview = gql`
    query ProviderOverview($where: RouteResourceWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  providers(where: $where, take: $take, skip: $skip) {
    id
    properties(where: {key: {equals: "logotype"}}) {
      ...PropertyItemFragment
    }
    content(
      where: {languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
  count: providerCount(where: $where)
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const DeleteProvider = gql`
    mutation DeleteProvider($where: RouteResourceWhereUniqueInput!) {
  deleteProvider(where: $where) {
    id
  }
}
    `;
export const DeleteProviderPool = gql`
    mutation DeleteProviderPool($where: ProviderPoolWhereUniqueInput!) {
  deleteProviderPool(where: $where) {
    id
  }
}
    `;
export const DeleteProviderTaxonomyConnection = gql`
    mutation DeleteProviderTaxonomyConnection($where: ProviderTaxonomyConnectionWhereUniqueInput!) {
  deleteProviderTaxonomyConnection(where: $where) {
    id
  }
}
    `;
export const ProviderCrud = gql`
    query ProviderCrud($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  provider(where: $where) {
    ...ProviderCrudFragment
  }
}
    ${ProviderCrudFragment}`;
export const ProviderPool = gql`
    query ProviderPool($where: RouteResourcePoolWhereUniqueInput!) {
  providerPool(where: $where) {
    id
    name
    networks {
      id
    }
    providers {
      id
    }
  }
}
    `;
export const ProviderTaxonomyConnections = gql`
    query ProviderTaxonomyConnections($currentLanguageId: String!, $providerId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  providerTaxonomyConnections(where: {providerId: {equals: $providerId}}) {
    id
    taxonomyItemId
    content(
      where: {languageId: {in: [$currentLanguageId]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const DynamicListProviders = gql`
    query DynamicListProviders($where: RouteResourceWhereInput, $search: RouteResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [RouteResourceOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput) {
  count: providersSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  providers: providersSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    createdAt
    createdBy {
      user_id
      name
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(
      where: {key: {in: $contentKeys}, status: {in: [APPROVED, DRAFT]}, languageId: {equals: "cka2r9yww001164rm5rp69iko"}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
    pools {
      id
      networks {
        id
      }
    }
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}`;
export const UpsertProviderCrud = gql`
    mutation UpsertProviderCrud($where: RouteResourceWhereUniqueInput!, $data: ProviderUpsertDataInput!, $current: ResourceCurrentInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  upsertProvider(where: $where, data: $data, current: $current) {
    ...ProviderCrudFragment
  }
}
    ${ProviderCrudFragment}`;
export const UpsertProviderPool = gql`
    mutation UpsertProviderPool($where: RouteResourcePoolWhereUniqueInput, $data: RouteResourcePoolUpsertDataInput!) {
  upsertProviderPool(where: $where, data: $data) {
    id
  }
}
    `;
export const UpsertProviderTaxonomyConnection = gql`
    mutation UpsertProviderTaxonomyConnection($where: ProviderTaxonomyConnectionWhereUniqueInput!, $data: ProviderTaxonomyConnectionUpsertDataInput!, $current: ResourceCurrentInput!) {
  upsertProviderTaxonomyConnection(where: $where, data: $data, current: $current) {
    id
    providerId
    taxonomyItemId
    network {
      id
    }
  }
}
    `;
export const ProvidersStatus = gql`
    query ProvidersStatus($where: RouteResourceWhereInput, $take: Int, $skip: Int, $contentQueryKeys: [String!], $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  count: providerCount(where: $where)
  providers(where: $where, take: $take, skip: $skip) {
    id
    createdAt
    updatedAt
    properties(
      where: {key: {in: ["published", "affiliate-link"]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}}
    ) {
      id
      key
      data
      contextId
    }
    content(
      where: {key: {in: $contentQueryKeys}, languageId: {equals: $defaultLanguageId}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const Logotypes = gql`
    query Logotypes($where: MediaItemWhereInput) {
  logo: mediaItems(where: $where) {
    id
    url
  }
}
    `;
export const RankingPositionNetwork = gql`
    query RankingPositionNetwork($defaultLanguageId: String!) {
  networks {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const DeleteSite = gql`
    mutation DeleteSite($where: SiteWhereUniqueInput!) {
  deleteSite(where: $where) {
    id
  }
}
    `;
export const Site = gql`
    query Site($where: SiteWhereUniqueInput!) {
  site(where: $where) {
    ...SiteFragment
  }
}
    ${SiteFragment}`;
export const DynamicListSites = gql`
    query DynamicListSites($where: SiteWhereInput, $search: ResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [SiteOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput) {
  count: sitesSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  sites: sitesSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    createdAt
    createdBy {
      user_id
      name
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(where: {key: {in: $contentKeys}}) {
      ...ContentItemFragment
    }
    language {
      ...LanguageFragment
    }
  }
}
    ${PropertyItemFragment}
${ContentItemFragment}
${LanguageFragment}`;
export const SitesStatus = gql`
    query SitesStatus($where: SiteWhereInput, $take: Int, $skip: Int) {
  sites(where: $where, take: $take, skip: $skip, orderBy: {url: asc}) {
    id
    url
    createdAt
    properties {
      id
      key
      data
    }
    language {
      id
      countryCode
      languageTag
    }
    vertical {
      id
      network {
        id
      }
    }
  }
  count: siteCount(where: $where)
}
    `;
export const NewsTaxStatus = gql`
    query NewsTaxStatus($where: RouteResourceWhereInput) {
  posts(where: $where) {
    id
    properties(where: {key: {in: ["tags", "section"]}}) {
      id
      key
      data
    }
    vertical {
      id
    }
  }
}
    `;
export const ProviderTaxStatus = gql`
    query ProviderTaxStatus($where: RouteResourceWhereInput, $defaultLanguageId: String!) {
  providers(where: $where) {
    id
    properties(where: {key: {contains: "-taxonomies"}}) {
      id
      key
      data
    }
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const TaxonomyItemsStatus = gql`
    query TaxonomyItemsStatus($where: RouteResourceWhereInput, $take: Int, $skip: Int, $contentQueryKeys: [String!], $defaultLanguageId: String!) {
  taxonomyItems(where: $where, take: $take, skip: $skip) {
    id
    subtype
    createdAt
    updatedAt
    parentId
    parent {
      id
    }
    properties(where: {key: {in: ["published-countries", "published"]}}) {
      id
      key
      data
    }
    content(
      where: {key: {in: $contentQueryKeys}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragment}`;
export const UpsertPropertyItem = gql`
    mutation UpsertPropertyItem($fieldId: String, $value: JSON!, $contextId: String, $resourceName: String, $resourceId: String, $propertyId: String) {
  upsertOnePropertyItemCustom(
    fieldId: $fieldId
    value: $value
    contextId: $contextId
    resourceName: $resourceName
    resourceId: $resourceId
    propertyId: $propertyId
  ) {
    ...PropertyItemFragment
  }
}
    ${PropertyItemFragment}`;
export const DeleteTaxonomyItem = gql`
    mutation DeleteTaxonomyItem($where: RouteResourceWhereUniqueInput!) {
  deleteTaxonomyItem(where: $where) {
    id
  }
}
    `;
export const DeleteTaxonomyItemPool = gql`
    mutation DeleteTaxonomyItemPool($where: TaxonomyItemPoolWhereUniqueInput) {
  deleteTaxonomyItemPool(where: $where) {
    id
  }
}
    `;
export const TaxonomyItemCrud = gql`
    query TaxonomyItemCrud($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  taxonomyItem(where: $where) {
    ...TaxonomyItemCrudFragment
  }
}
    ${TaxonomyItemCrudFragment}`;
export const TaxonomyItemPool = gql`
    query TaxonomyItemPool($where: RouteResourcePoolWhereUniqueInput!) {
  taxonomyItemPool(where: $where) {
    id
    name
    networks {
      id
    }
    taxonomyItems {
      id
    }
  }
}
    `;
export const DynamicListTaxonomyItems = gql`
    query DynamicListTaxonomyItems($where: RouteResourceWhereInput, $search: RouteResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [RouteResourceOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput) {
  count: taxonomyItemsSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  taxonomyItems: taxonomyItemsSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    parentId
    subtype
    createdAt
    updatedAt
    createdBy {
      user_id
      name
    }
    parent {
      id
      content(
        where: {key: {in: $contentKeys}, status: {in: [APPROVED, DRAFT]}, languageId: {equals: "cka2r9yww001164rm5rp69iko"}}
        orderBy: {status: asc}
      ) {
        ...ContentItemFragment
      }
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(
      where: {key: {in: $contentKeys}, status: {in: [APPROVED, DRAFT]}, languageId: {equals: "cka2r9yww001164rm5rp69iko"}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
    pools {
      id
      networks {
        id
      }
    }
  }
}
    ${ContentItemFragment}
${PropertyItemFragment}`;
export const UpsertTaxonomyItemCrud = gql`
    mutation UpsertTaxonomyItemCrud($where: RouteResourceWhereUniqueInput!, $data: TaxonomyItemUpsertDataInput!, $current: ResourceCurrentInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  upsertTaxonomyItem(where: $where, data: $data, current: $current) {
    ...TaxonomyItemCrudFragment
  }
}
    ${TaxonomyItemCrudFragment}`;
export const UpsertTaxonomyItemPool = gql`
    mutation UpsertTaxonomyItemPool($where: RouteResourcePoolWhereUniqueInput, $data: RouteResourcePoolUpsertDataInput!) {
  upsertTaxonomyItemPool(where: $where, data: $data) {
    id
  }
}
    `;
export const TemplatesOverview = gql`
    query TemplatesOverview($where: TemplateWhereInput!) {
  templates(where: $where) {
    id
    createdAt
    updatedAt
    type
    subtype
    network {
      id
    }
    content {
      ...ContentItemFragment
    }
    fields {
      id
      required
      index
      group
      key
      type
      hidden
      list
      data
      generatePages
      context
      resourceType
      isDefaultField
      defaultTranslationType
      displayType
      roles
      content {
        ...ContentItemFragment
      }
    }
    groups {
      id
      name
      index
      extended
      generalGroup {
        id
        name
        index
      }
      data
    }
  }
}
    ${ContentItemFragment}`;
export const UpdateUser = gql`
    mutation UpdateUser($id: String!, $name: String, $roles: [String!], $permissions: [String!]) {
  updateUser(id: $id, name: $name, roles: $roles, permissions: $permissions) {
    ...UserFragment
  }
}
    ${UserFragment}`;
export const DeleteVertical = gql`
    mutation DeleteVertical($where: VerticalWhereUniqueInput!) {
  deleteVertical(where: $where) {
    id
  }
}
    `;
export const UpsertVertical = gql`
    mutation UpsertVertical($where: VerticalWhereUniqueInput!, $data: VerticalUpsertDataInput!, $current: VerticalCurrentInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!) {
  upsertVertical(where: $where, data: $data, current: $current) {
    ...VerticalCrudFragment
  }
}
    ${VerticalCrudFragment}`;
export const Vertical = gql`
    query Vertical($where: VerticalWhereUniqueInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!) {
  vertical(where: $where) {
    ...VerticalCrudFragment
  }
}
    ${VerticalCrudFragment}`;
export const SitesForRedirects = gql`
    query SitesForRedirects($where: SiteWhereInput, $take: Int, $skip: Int) {
  sites(where: $where, take: $take, skip: $skip) {
    id
    url
    properties(where: {key: {in: ["name", "redirect-rules"]}}) {
      id
      key
      data
      createdAt
      updatedAt
    }
    language {
      id
      languageCode
      languageTag
      countryCode
    }
  }
  count: siteCount(where: $where)
}
    `;